import React, { FCC } from 'react'

import { Flex, FlexDivProps } from '../Box'
import { Spinner } from './Spinner'

export interface SpinnerFlexProps {
  primary?: boolean
  size?: string
}

export const SpinnerFlex: FCC<SpinnerFlexProps & FlexDivProps> = ({
  ref: forwardedRef,
  primary,
  size,
  ...props
}) => (
  <Flex
    ref={forwardedRef}
    justifyContent="center"
    alignItems="center"
    {...props}
  >
    <Spinner primary={primary} size={size} />
  </Flex>
)

SpinnerFlex.displayName = 'SpinnerFlex'
